import React from 'react'
import './CheckBox.css'

function CheckBox({ height, width, valueId, onChange, defaultValue }) {

    return (
        <label className='toggle'>
            <input type='checkbox' name='toggle' defaultChecked={defaultValue} className='switch' valueId={valueId} onChange={(e) => {
                onChange(parseInt(e.target.getAttribute("valueId")), e.target.checked)
            }} />
            <span className='slider'></span>
        </label>
    )
}

export default CheckBox